import React from 'react'

export function useWebSocket(
  url: string | undefined,
  onMessage: (message: any) => void
) {
  const socketRef = React.useRef<WebSocket | null>(null)
  const [shouldReconnect, setShouldReconnect] = React.useState(true)

  function createSocketConnection() {
    if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
      console.warn('Devices WebSocket is already open.')
      return
    }

    const socket = new WebSocket(`${url}`)
    socketRef.current = socket

    socket.onopen = (event) => {
      console.log('Devices WebSocket connection opened:', event)
    }

    socket.onmessage = (event: MessageEvent) => {
      try {
        const message = JSON.parse(event.data)
        onMessage(message)
      } catch (error) {
        console.error('Devices Error parsing WebSocket message:', error)
      }
    }

    socket.onerror = (event: Event) => {
      console.error('Devices WebSocket error observed:', event)
    }

    socket.onclose = (event: CloseEvent) => {
      console.log('Devices WebSocket closed with code:', event.code)
      if (event.code !== 1000 && event.code !== 1001 && shouldReconnect) {
        console.log(
          'Devices: Abnormal closure, attempting to reconnect... ',
          new Date().toISOString()
        )
        setTimeout(createSocketConnection, 3000) // Retry after 3 seconds
      }
    }
  }

  function sendData(payload: Record<string, any>) {
    if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
      try {
        socketRef.current.send(JSON.stringify(payload))
        console.log('Message Sent', payload)
      } catch (error) {
        console.error('Devices: Failed to send WebSocket message:', error)
      }
    } else {
      console.warn('Devices WebSocket is not open. Cannot send message.')
    }
  }

  function closeSocketConnection() {
    setShouldReconnect(false)
    if (socketRef.current) {
      console.log('Closing Devices WebSocket connection...')
      socketRef.current.onclose = null // Remove event listener
      socketRef.current.close()
      socketRef.current = null // Ensure reference is cleared
    }
  }

  return {
    createSocketConnection,
    sendData,
    closeSocketConnection,
  }
}
